import {Input as InputBase} from '@yandex-delivery/blocks'
import React from 'react'
import {Controller, useFormContext} from 'react-hook-form'

import {scoped} from '../../utils'
import type {Props} from './Input.type'

export function Input({
  name,
  helperText,
  rules,
  shouldUnregister = false,
  defaultValue = '',
  ...otherProps
}: Props): React.ReactElement {
  const {control, watch} = useFormContext()

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({field: {onChange, onBlur, name}, fieldState: {invalid, error}}) => {
        return (
          <InputBase
            error={invalid}
            helperText={error?.message || helperText}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            value={watch(name, defaultValue)}
            {...otherProps}
          />
        )
      }}
      rules={rules}
      shouldUnregister={shouldUnregister}
    />
  )
}

export const ScopedInput = scoped(InputBase)
